// Path prefixes for promo landing funnels that reuse the shared homepage
// sections (Hero, Safety, DontWait, FAQSection, QualifyBanner, Header). Those
// sections navigate through useNavi/QualifyBanner and need to know which
// funnel they're rendered under so "QUALIFY NOW" stays inside that funnel
// instead of always dropping the visitor onto the root /eligibility flow.
const PROMO_PREFIXES = ["/promo65", "/promo49"];

export const getPromoPrefix = (pathname) =>
  PROMO_PREFIXES.find((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)) || "";
